import React from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Box,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";

export default function HorseRacingTableBody({
  horseRacingData,
  handleInputChange,
  handleDeleteRow,
  loading,
  isViewer,
}) {
  return (
    <TableBody>
      {horseRacingData.map((row, rowIndex) => (
        <TableRow
          key={`race-${rowIndex}`}
          sx={{
            "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
            "&:hover": { backgroundColor: "#f0f0f0" },
          }}
        >
          <TableCell
            component="th"
            scope="row"
            sx={{
              borderRight: "1px solid #e0e0e0",
              backgroundColor: "#e3f2fd",
              fontWeight: "bold",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body2" fontWeight="bold" color="primary">
                Race {rowIndex + 1}
              </Typography>
              {!isViewer && (
                <IconButton
                  onClick={() => handleDeleteRow(rowIndex)}
                  disabled={loading || horseRacingData.length <= 1}
                  size="small"
                  sx={{
                    color: horseRacingData.length <= 1 ? "#ccc" : "#d32f2f",
                    "&:hover": {
                      backgroundColor:
                        horseRacingData.length <= 1 ? "transparent" : "#ffcdd2",
                    },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
          </TableCell>
          {row.map((horse, colIndex) => (
            <TableCell
              key={`horse-${rowIndex}-${colIndex}`}
              sx={{
                borderRight: "1px solid #e0e0e0",
                padding: "12px",
                verticalAlign: "top",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                  minHeight: 120,
                }}
              >
                <TextField
                  size="small"
                  fullWidth
                  label="Multiplier"
                  value={horse.multiplier}
                  onChange={(e) =>
                    handleInputChange(
                      rowIndex,
                      colIndex,
                      "multiplier",
                      e.target.value
                    )
                  }
                  variant="outlined"
                  disabled={loading}
                  type="number"
                  step="0.01"
                  inputProps={{ min: 0 }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#f8f9fa",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#1976d2",
                      fontWeight: 500,
                    },
                  }}
                />
                <TextField
                  size="small"
                  fullWidth
                  label="Win Probability"
                  value={horse.winProbability}
                  onChange={(e) =>
                    handleInputChange(
                      rowIndex,
                      colIndex,
                      "winProbability",
                      e.target.value
                    )
                  }
                  variant="outlined"
                  disabled={loading}
                  type="number"
                  step="0.0001"
                  inputProps={{ min: 0, max: 1 }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#f8f9fa",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#388e3c",
                      fontWeight: 500,
                    },
                  }}
                />
                <Typography
                  variant="body3"
                  color="textSecondary"
                  sx={{ textAlign: "center" }}
                >
                  RTP:{" "}
                  {Math.round(
                    horse.multiplier *
                      (parseFloat(horse.winProbability) * 100 || 0)
                  )}
                  %
                </Typography>
              </Box>
            </TableCell>
          ))}
          <TableCell
            sx={{
              padding: "12px",
              verticalAlign: "middle",
              textAlign: "center",
              backgroundColor: "#fff3e0",
            }}
          >
            {(() => {
              const totalProbability = row.reduce(
                (sum, horse) => sum + (parseFloat(horse.winProbability) || 0),
                0
              );
              const totalRtp = row.reduce(
                (sum, horse) =>
                  sum +
                  parseFloat(horse.multiplier) *
                    (parseFloat(horse.winProbability) || 0),
                0
              );
              const isExactlyOne = Math.abs(totalProbability - 1) < 0.0001;
              const avgRtp = totalRtp / row.length || 0;
              return (
                <>
                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{
                      color: isExactlyOne ? "#2e7d32" : "#d32f2f",
                      fontSize: "0.875rem",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      backgroundColor: isExactlyOne ? "#e8f5e8" : "#ffebee",
                      display: "inline-block",
                    }}
                  >
                    {totalProbability.toFixed(4)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ mt: 1 }}
                  >
                    Avg RTP: {Math.round(avgRtp * 1000) / 10}%
                  </Typography>
                </>
              );
            })()}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}
